import { useCallback, useRef, useState } from 'react';

export type ToastTone = 'info' | 'success' | 'error';

export interface ToastItem {
  id: number;
  message: string;
  tone: ToastTone;
  /** 失败提示可带一个“重试”动作。 */
  action?: { label: string; run: () => void };
}

export interface ToastApi {
  toasts: ToastItem[];
  push: (message: string, tone?: ToastTone, action?: ToastItem['action']) => void;
  dismiss: (id: number) => void;
}

/** 轻量 Toast：默认 2.6s 自动消失，可带“重试”动作。 */
export function useToast(): ToastApi {
  const [toasts, setToasts] = useState<ToastItem[]>([]);
  const seq = useRef(0);

  const dismiss = useCallback((id: number) => {
    setToasts((current) => current.filter((item) => item.id !== id));
  }, []);

  const push = useCallback((message: string, tone: ToastTone = 'info', action?: ToastItem['action']) => {
    seq.current += 1;
    const id = seq.current;
    setToasts((current) => [...current.slice(-2), { id, message, tone, action }]);
    window.setTimeout(() => setToasts((current) => current.filter((item) => item.id !== id)), 2600);
  }, []);

  return { toasts, push, dismiss };
}
